// base rc-drawer 4.4.2
import Drawer from './src/DrawerWrapper';
export default Drawer;
